const storage = localStorage
export const SessionID = localStorage.getItem('sessionId')
export default storage
